import { SelectDropdownObserver } from '../shared/select-dropdown-v2';
import ButtonHandler from '../shared/product/button-handler';

export default class ProductSelectDropdown {
  constructor(container, onChangeUI) {
    this.buttonHandler = new ButtonHandler();
    this.select = new SelectDropdownObserver(container, this.handleChange);
    this.onChangeUI = onChangeUI;
  }

  setCorrectVariant = (productId) => {
    Object.values(window.variantDataSelector.data).some((currentItem) => {
      if (Number(currentItem.productId) === Number(productId)) {
        window.currentVariantStorage.setState({ currentVariant: currentItem, subscription: 'subscription' });

        return true;
      }

      return false;
    });
  };

  handleChange = (productId) => {
    this.setCorrectVariant(productId);
    this.onChangeUI(productId);
  };

  init = () => {
    this.select.init();
  };
}
